import { AppStyle } from '../../../models/app-style.type';

const defaultContainerHeight = 128;
const defaultMaxBarHeight = 64;

export const calendarChartContainerHeightMap: Record<AppStyle, number> = {
  ipt: defaultContainerHeight,
  pp: 168,
  default: defaultContainerHeight,
};

export const calendarChartContainerHeightMapInTileRow: Record<
  AppStyle,
  number
> = {
  ...calendarChartContainerHeightMap,
  default: 96,
};

export const calendarChartMaxBarHeightMap: Record<AppStyle, number> = {
  ipt: defaultMaxBarHeight,
  pp: 96,
  default: defaultMaxBarHeight,
};

export const calendarChartMaxBarHeightMapInTileRow: Record<AppStyle, number> = {
  ...calendarChartMaxBarHeightMap,
  default: 40,
};
